module.exports = __webpack_public_path__ + "static/3(2)-e76c3185858406e420fd644997d92f2f.jpg";